import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

import { setAgentFilterSearchParam } from "@/pages/agent/utils/agent-search-params.utils";
import {
  AGENT_ACTIVITY_ENTITY_SEARCH_PARAM,
  AGENT_ACTIVITY_PROJECT_ID_SEARCH_PARAM,
  AGENT_ACTIVITY_ROUTINE_ID_SEARCH_PARAM,
  AGENT_ACTIVITY_SEARCH_QUERY_SEARCH_PARAM,
  AGENT_ACTIVITY_TASK_ID_SEARCH_PARAM,
} from "@/store/agent-overlay/types";

export const ALL_ACTIVITY_PROJECTS = "all-activity-projects";
export const ALL_ACTIVITY_ENTITIES = "all-activity-entities";

export const useAgentActivitiesSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const projectFilter =
    searchParams.get(AGENT_ACTIVITY_PROJECT_ID_SEARCH_PARAM) ?? ALL_ACTIVITY_PROJECTS;
  const taskId = searchParams.get(AGENT_ACTIVITY_TASK_ID_SEARCH_PARAM);
  const routineId = searchParams.get(AGENT_ACTIVITY_ROUTINE_ID_SEARCH_PARAM);
  const entityFilter =
    searchParams.get(AGENT_ACTIVITY_ENTITY_SEARCH_PARAM) ?? ALL_ACTIVITY_ENTITIES;
  const searchQuery = searchParams.get(AGENT_ACTIVITY_SEARCH_QUERY_SEARCH_PARAM) ?? "";

  const updateActivityFilters = useCallback(
    ({
      nextProjectFilter,
      nextTaskId,
      nextRoutineId,
      nextEntityFilter,
      nextSearchQuery,
    }: {
      nextProjectFilter?: string;
      nextTaskId?: string | null;
      nextRoutineId?: string | null;
      nextEntityFilter?: string;
      nextSearchQuery?: string;
    }) => {
      setSearchParams(
        previousSearchParams => {
          const nextSearchParams = new URLSearchParams(previousSearchParams);
          setAgentFilterSearchParam({
            searchParams: nextSearchParams,
            name: AGENT_ACTIVITY_PROJECT_ID_SEARCH_PARAM,
            value: nextProjectFilter,
            defaultValue: ALL_ACTIVITY_PROJECTS,
          });
          setAgentFilterSearchParam({
            searchParams: nextSearchParams,
            name: AGENT_ACTIVITY_TASK_ID_SEARCH_PARAM,
            value: nextTaskId === null ? "" : nextTaskId,
            defaultValue: "",
          });
          setAgentFilterSearchParam({
            searchParams: nextSearchParams,
            name: AGENT_ACTIVITY_ROUTINE_ID_SEARCH_PARAM,
            value: nextRoutineId === null ? "" : nextRoutineId,
            defaultValue: "",
          });
          setAgentFilterSearchParam({
            searchParams: nextSearchParams,
            name: AGENT_ACTIVITY_ENTITY_SEARCH_PARAM,
            value: nextEntityFilter,
            defaultValue: ALL_ACTIVITY_ENTITIES,
          });
          setAgentFilterSearchParam({
            searchParams: nextSearchParams,
            name: AGENT_ACTIVITY_SEARCH_QUERY_SEARCH_PARAM,
            value: nextSearchQuery?.slice(0, 200),
            defaultValue: "",
          });
          return nextSearchParams;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  return {
    projectFilter,
    taskId,
    routineId,
    entityFilter,
    searchQuery: searchQuery.slice(0, 200),
    updateActivityFilters,
  };
};
